import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { getCellValue } from '../../../util';

function PercentageCell({ cell }) {
  const { column, row } = cell;
  const value = getCellValue(row?.original, column?.accessorKey);
  return (
    <div className="mlr5">
      <TextStyle>{`${value || 0} %`}</TextStyle>
    </div>
  );
}

export default PercentageCell;
